import * as React from "react";
import SliderNavigation from "../Common/Slider/Navigation";
import Slider from "../Common/Slider";
import Section from "../Layout/Section";
import Link from "../UI/Link";
import Media from "../Common/Media";
import * as styles from "./otherOpportunities.module.css";
import TemplateString from "../Common/TemplateString";

const OtherOpportunities = ({title, description, items}) => {
    return (
        <Section>
            <Slider
                title={title}
                desc={description}
                navigation={<SliderNavigation />}
                sliderClassName={styles.otherOpportunities__slider}
                containerClassName={styles.otherOpportunities__sliderContainer}
                titleClassName={styles.otherOpportunities__sliderTitle}
            >
                {items.map(({id, title: itemTitle, url, image}) => (
                    <div key={id}>
                        <div className={styles.otherOpportunities__card}>
                            <div>
                                <h3 className={styles.otherOpportunities__cardTitle}>
                                    <TemplateString template={itemTitle} />
                                </h3>
                            </div>
                            <div>
                                <Link to={url} withArrow className={styles.otherOpportunities__cardLink}>
                                    Подробнее
                                </Link>
                                <Media media={{content: image}} className={styles.otherOpportunities__cardMedia} />
                            </div>
                            <div className={styles.otherOpportunities__cardGradient} />
                        </div>
                    </div>
                ))}
            </Slider>
        </Section>
    );
};

export default OtherOpportunities;
